import { ExpensableBudgetFragment } from 'generated/resources/graphql'
import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'

import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'
import { BudgetOption } from 'modules/finance/hooks/useBudgets'

import BudgetField from './BudgetField'
import { shouldShowBlock } from './form/schema'

interface Props extends PermissionsProps, CustomizationProps {
  expensableBudget?: ExpensableBudgetFragment | null
  budgetOptions: BudgetOption[]
  loading: boolean
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
}

const Budget = (props: Props) => {
  const showBlock = shouldShowBlock(
    props.budgetOptions,
    props.customizationFields,
    props.resourceType
  )
  if (!showBlock) return null

  return <BudgetField {...props} fieldIdentifier="budget_id" />
}

export default Budget
